import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'components/Link';
import { bindGa } from 'helpers/analytics';
import s from './HeaderTab.scss';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

class HeaderTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subSections: null,
      showMoreItems: false,
      highlighterLeft: 0,
      highlighterWidth: 0,
    };
    this.timer = null;
    this.activeTabRef = null;
    this.handleClick = this.handleClick.bind(this);
    this.dropdownRef = React.createRef(null);
  }

  componentDidMount() {
    const { active } = this.props;
    if (active) {
      this.setSubSubsection(undefined, active);
    } else {
      this.timer = setTimeout(() => {
        this.setSubSubsection();
      }, 1000);
    }
    document.addEventListener('click', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    const { active, subSections } = this.props;
    if (!this.state.subSections && subSections instanceof Array) {
      this.setSubSubsection();
    }
    if (
      (active && active !== prevProps.active) ||
      (active &&
        subSections instanceof Array &&
        subSections !== prevProps.subSections)
    ) {
      this.setSubSubsection(undefined, active);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    clearTimeout(this.timer);
  }

  handleClickOutside = event => {
    if (
      this.dropdownRef.current &&
      !this.dropdownRef.current.contains(event.target)
    ) {
      this.setState({
        showMoreItems: false,
      });
    }
  };

  updateHighlighterPosition = () => {
    if (!this.activeTabRef) {
      return;
    }
    const activeAnchor = this.activeTabRef;
    const left = activeAnchor && activeAnchor.offsetLeft;
    const width = activeAnchor && activeAnchor.offsetWidth;
    this.setState({
      highlighterLeft: left,
      highlighterWidth: width,
    });
  };

  setSubSubsection = (id, name, initalMenuItems) => {
    const { subSections } = this.props;
    if (!(subSections instanceof Array && subSections.length > 0)) {
      return;
    }

    let finalSubSections;
    if (id || (typeof name === 'string' && name.trim())) {
      finalSubSections = subSections.map(item => {
        const obj = { ...item };
        if (id) {
          obj.active = obj.id === id;
        } else {
          obj.active = obj.name === name;
        }
        return obj;
      });
    } else {
      finalSubSections = [...subSections];
      const activeItem = finalSubSections.filter(item => item.active);
      if (activeItem.length === 0 && finalSubSections.length > 0) {
        finalSubSections[0].active = true;
      }
    }
    const activeObject = finalSubSections.find(
      section => section.active === true,
    );

    if (activeObject) {
      // Removing the active tab object from its current position
      const index = finalSubSections.indexOf(activeObject);
      if (index + 1 > initalMenuItems) {
        if (index > -1) {
          finalSubSections.splice(index, 1);
        }

        // Inserting the active tab object at the 2nd position
        finalSubSections.splice(1, 0, activeObject);
      }
    }

    this.setState(
      {
        subSections: finalSubSections,
      },
      () => {
        this.updateHighlighterPosition();
      },
    );
  };

  @bindGa({})
  handleClick(event, dataObj, initalMenuItems) {
    event.preventDefault();
    const { ga4Type, ga4Category, onChangeCallback = () => {} } = this.props;
    this.setSubSubsection(
      dataObj.clickedItem.id,
      dataObj.clickedItem.name,
      initalMenuItems,
    );
    onChangeCallback(dataObj);
    this.setState({
      showMoreItems: false,
    });
    if (ga4Type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: `${ga4Type}`,
        label: `${dataObj?.clickedItem?.name}`,
        category: `${'tab_change' || ga4Category}`,
      });
    }
  }

  getListItem = (section, index, initalMenuItems) => {
    const link = section.link || section.path;
    if (link) {
      return (
        <Link
          ref={myRef => {
            if (myRef && section.active) {
              this.activeTabRef = myRef;
            }
          }}
          key={section.name}
          to={link}
          className={section.active ? s.active : ''}
          // isspa={!!section.isspa}
          onClick={event =>
            this.handleClick(event, {
              clickedItem: section,
              initalMenuItems,
            })
          }
          data-newga={`${this.props.newga}${section.name}/${index}`}
          aria-label={section.name}
        >
          {section.name}
        </Link>
      );
    }
    return (
      <li
        onClick={event =>
          this.handleClick(event, {
            clickedItem: section,
          })
        }
        className={section.active ? s.active : ''}
      >
        {section.name}
      </li>
    );
  };

  renderMoreMenu(subSections, initalMenuItems) {
    const moreMenuClass = classNames({
      [s.moreMenuItems]: true,
      [s.hide]: !this.state.showMoreItems,
    });
    return subSections.length > initalMenuItems ? (
      <div className={s.moreMenuDots} ref={this.dropdownRef}>
        <span onClick={this.showMoreItems} className={s.dots}>
          <i />
          <i />
          <i />
        </span>
        <div className={`${moreMenuClass} ${s.active}`}>
          {subSections
            .slice(initalMenuItems)
            .map((section, index) =>
              this.getListItem(section, index, initalMenuItems),
            )}
        </div>
      </div>
    ) : null;
  }
  showMoreItems = status => {
    const { showMoreItems } = this.state;
    this.setState({
      showMoreItems: typeof status === 'boolean' ? status : !showMoreItems,
    });
  };

  renderHighlighter = () => {
    const { highlighterLeft, highlighterWidth } = this.state;
    const _styles =
      (highlighterLeft || highlighterLeft === 0) && highlighterWidth
        ? {
            left: highlighterLeft,
            width: highlighterWidth,
            right: 'auto',
          }
        : {};
    return <span className={s.highlighter} style={_styles} />;
  };

  render() {
    const { contentWraperClass } = this.props;
    const { subSections } = this.state;
    const initalMenuItems = this.props.initalMenuItems || 9;
    if (subSections && subSections instanceof Array) {
      const headerTabClassName = classNames({
        [s.headerTab]: true,
        [s.themewhite]: this.props.isWhiteTheme,
        [contentWraperClass]: contentWraperClass,
      });
      return (
        <div className={headerTabClassName}>
          <div className={s.tabList}>
            {subSections
              .slice(0, initalMenuItems)
              .map((section, index) =>
                this.getListItem(section, index, initalMenuItems),
              )}
            {this.renderMoreMenu(subSections, initalMenuItems)}
            {this.renderHighlighter()}
          </div>
        </div>
      );
    }
    return null;
  }
}

HeaderTab.defaultProps = {
  isWhiteTheme: false,
  newga: '',
  contentWraperClass: '',
  ga4Type: '',
  ga4Category: '',
};

HeaderTab.propTypes = {
  subSections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChangeCallback: PropTypes.func.isRequired,
  isWhiteTheme: PropTypes.bool,
  newga: PropTypes.string,
  contentWraperClass: PropTypes.string,
  ga4Type: PropTypes.string,
  ga4Category: PropTypes.string,
};

export default HeaderTab;
